module.exports = __webpack_public_path__ + "static/media/hover-twitter.573ba0ec.svg";